import React from 'react';

export const ArtifactIllustration: React.FC = () => (
  <svg width="280" height="65" viewBox="0 0 268 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_381_17846)">
      <rect
        x="15.9344"
        y="9.76404"
        width="240"
        height="68.5"
        rx="4"
        transform="rotate(3.4904 15.9344 9.76404)"
        fill="white"
        shapeRendering="crispEdges"
      />
      <rect
        x="16.403"
        y="10.2936"
        width="239"
        height="67.5"
        rx="3.5"
        transform="rotate(3.4904 16.403 10.2936)"
        stroke="#DEDFE0"
        shapeRendering="crispEdges"
      />
      <path
        d="M34.7842 31.3282C35.9216 30.3216 34.6923 27.0749 32.0387 24.0765C29.385 21.0781 26.3118 19.4634 25.1744 20.4699C24.0371 21.4765 25.2663 24.7232 27.92 27.7216C30.5737 30.72 33.6469 32.3347 34.7842 31.3282Z"
        stroke="#696D6F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.8019 27.9584C34.8003 25.3047 36.415 22.2315 35.4085 21.0942C34.4019 19.9568 31.1552 21.1861 28.1568 23.8397C25.1584 26.4934 23.5436 29.5666 24.5502 30.704C25.5568 31.8413 28.8035 30.6121 31.8019 27.9584Z"
        stroke="#696D6F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.9553 26.2733C30.162 26.2859 30.3398 26.1285 30.3524 25.9218C30.3651 25.7151 30.2077 25.5373 30.001 25.5247C29.7942 25.5121 29.6164 25.6694 29.6038 25.8761C29.5912 26.0829 29.7486 26.2607 29.9553 26.2733Z"
        stroke="#696D6F"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="52.2542"
        y="22.0429"
        width="197"
        height="11"
        rx="2"
        transform="rotate(3.4904 52.2542 22.0429)"
        fill="#EEEEEE"
      />
      <rect
        x="21.214"
        y="38.1831"
        width="71.3333"
        height="7.28516"
        rx="2"
        transform="rotate(3.4904 21.214 38.1831)"
        fill="#DEDFE0"
      />
      <rect
        x="98.4039"
        y="42.8912"
        width="71.3333"
        height="7.28516"
        rx="2"
        transform="rotate(3.4904 98.4039 42.8912)"
        fill="#DEDFE0"
      />
      <rect
        x="175.594"
        y="47.5994"
        width="71.3333"
        height="7.28516"
        rx="2"
        transform="rotate(3.4904 175.594 47.5994)"
        fill="#DEDFE0"
      />
      <rect
        x="20.4834"
        y="50.1608"
        width="71.3333"
        height="3"
        rx="1.5"
        transform="rotate(3.4904 20.4834 50.1608)"
        fill="#EEEEEE"
      />
      <rect
        x="97.6733"
        y="54.869"
        width="71.3333"
        height="3"
        rx="1.5"
        transform="rotate(3.4904 97.6733 54.869)"
        fill="#EEEEEE"
      />
      <rect
        x="174.863"
        y="59.5771"
        width="71.3333"
        height="3"
        rx="1.5"
        transform="rotate(3.4904 174.863 59.5771)"
        fill="#EEEEEE"
      />
      <rect
        x="20.179"
        y="55.1516"
        width="71.3333"
        height="3"
        rx="1.5"
        transform="rotate(3.4904 20.179 55.1516)"
        fill="#EEEEEE"
      />
      <rect
        x="97.3689"
        y="59.8597"
        width="71.3333"
        height="3"
        rx="1.5"
        transform="rotate(3.4904 97.3689 59.8597)"
        fill="#EEEEEE"
      />
      <rect
        x="19.8746"
        y="60.1423"
        width="71.3333"
        height="3"
        rx="1.5"
        transform="rotate(3.4904 19.8746 60.1423)"
        fill="#EEEEEE"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_381_17846"
        x="-0.235977"
        y="-0.235962"
        width="267.725"
        height="106.984"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_381_17846" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_381_17846"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const TableIllustration: React.FC = () => (
  <svg width="222" height="51" viewBox="0 0 225 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_381_12238)">
      <g clipPath="url(#clip1_381_12238)">
        <mask id="path-3-inside-1_381_12238" fill="white">
          <path d="M3.14029 0L15.9869 0.448612L15.3588 18.4338L2.51223 17.9852L3.14029 0Z" />
        </mask>
        <path
          d="M3.14029 0L15.9869 0.448612L15.3588 18.4338L2.51223 17.9852L3.14029 0Z"
          fill="#F7F9FA"
        />
        <path
          d="M15.3588 18.4338L15.37 18.1127L2.52345 17.664L2.51223 17.9852L2.50102 18.3064L15.3476 18.755L15.3588 18.4338Z"
          fill="#EDEDED"
          mask="url(#path-3-inside-1_381_12238)"
        />
        <mask id="path-5-inside-2_381_12238" fill="white">
          <path d="M15.9869 0.448608L57.9613 1.91439L57.3332 19.8996L15.3588 18.4338L15.9869 0.448608Z" />
        </mask>
        <path
          d="M15.9869 0.448608L57.9613 1.91439L57.3332 19.8996L15.3588 18.4338L15.9869 0.448608Z"
          fill="#F7F9FA"
        />
        <path
          d="M57.3332 19.8996L57.3444 19.5784L15.37 18.1127L15.3588 18.4338L15.3476 18.755L57.322 20.2208L57.3332 19.8996Z"
          fill="#EDEDED"
          mask="url(#path-5-inside-2_381_12238)"
        />
        <rect
          x="23.4506"
          y="7.71161"
          width="14.1875"
          height="4"
          rx="2"
          transform="rotate(2 23.4506 7.71161)"
          fill="#A0A7AB"
        />
        <rect
          x="57.4634"
          y="7.05408"
          width="0.32136"
          height="7.6989"
          transform="rotate(2 57.4634 7.05408)"
          fill="#DEDFE0"
        />
        <mask id="path-9-inside-3_381_12238" fill="white">
          <path d="M57.9613 1.91437L99.9357 3.38015L99.3076 21.3654L57.3332 19.8996L57.9613 1.91437Z" />
        </mask>
        <path
          d="M57.9613 1.91437L99.9357 3.38015L99.3076 21.3654L57.3332 19.8996L57.9613 1.91437Z"
          fill="#F7F9FA"
        />
        <path
          d="M99.3076 21.3654L99.3189 21.0442L57.3444 19.5784L57.3332 19.8996L57.322 20.2207L99.2964 21.6865L99.3076 21.3654Z"
          fill="#EDEDED"
          mask="url(#path-9-inside-3_381_12238)"
        />
        <rect
          x="65.425"
          y="9.17731"
          width="13.2031"
          height="4"
          rx="2"
          transform="rotate(2 65.425 9.17731)"
          fill="#A0A7AB"
        />
        <path
          d="M82.7366 11.4615L83.6665 12.4587L84.6636 11.5288"
          stroke="#1198FF"
          strokeWidth="0.32136"
          strokeLinecap="round"
        />
        <rect
          x="99.4378"
          y="8.51202"
          width="0.32136"
          height="7.6989"
          transform="rotate(2 99.4378 8.51202)"
          fill="#DEDFE0"
        />
        <mask id="path-14-inside-4_381_12238" fill="white">
          <path d="M99.9357 3.38019L141.91 4.84597L141.282 22.8312L99.3076 21.3654L99.9357 3.38019Z" />
        </mask>
        <path
          d="M99.9357 3.38019L141.91 4.84597L141.282 22.8312L99.3076 21.3654L99.9357 3.38019Z"
          fill="#F7F9FA"
        />
        <path
          d="M141.282 22.8312L141.293 22.51L99.3189 21.0442L99.3076 21.3654L99.2964 21.6866L141.271 23.1523L141.282 22.8312Z"
          fill="#EDEDED"
          mask="url(#path-14-inside-4_381_12238)"
        />
        <rect
          x="107.399"
          y="10.6432"
          width="14.1875"
          height="4"
          rx="2"
          transform="rotate(2 107.399 10.6432)"
          fill="#A0A7AB"
        />
        <rect
          x="141.412"
          y="9.98566"
          width="0.32136"
          height="7.6989"
          transform="rotate(2 141.412 9.98566)"
          fill="#DEDFE0"
        />
        <mask id="path-18-inside-5_381_12238" fill="white">
          <path d="M141.91 4.84595L183.885 6.31173L183.256 24.2969L141.282 22.8312L141.91 4.84595Z" />
        </mask>
        <path
          d="M141.91 4.84595L183.885 6.31173L183.256 24.2969L141.282 22.8312L141.91 4.84595Z"
          fill="#F7F9FA"
        />
        <path
          d="M183.256 24.2969L183.268 23.9758L141.293 22.51L141.282 22.8312L141.271 23.1523L183.245 24.6181L183.256 24.2969Z"
          fill="#EDEDED"
          mask="url(#path-18-inside-5_381_12238)"
        />
        <rect
          x="149.374"
          y="12.1089"
          width="14.1875"
          height="4"
          rx="2"
          transform="rotate(2 149.374 12.1089)"
          fill="#A0A7AB"
        />
        <rect
          x="183.387"
          y="11.4514"
          width="0.32136"
          height="7.6989"
          transform="rotate(2 183.387 11.4514)"
          fill="#DEDFE0"
        />
        <mask id="path-22-inside-6_381_12238" fill="white">
          <path d="M183.885 6.31171L225.859 7.77749L225.231 25.7627L183.256 24.2969L183.885 6.31171Z" />
        </mask>
        <path
          d="M183.885 6.31171L225.859 7.77749L225.231 25.7627L183.256 24.2969L183.885 6.31171Z"
          fill="#F7F9FA"
        />
        <path
          d="M225.231 25.7627L225.242 25.4415L183.268 23.9758L183.256 24.2969L183.245 24.6181L225.22 26.0839L225.231 25.7627Z"
          fill="#EDEDED"
          mask="url(#path-22-inside-6_381_12238)"
        />
        <rect
          x="191.348"
          y="13.5747"
          width="14.1875"
          height="4"
          rx="2"
          transform="rotate(2 191.348 13.5747)"
          fill="#A0A7AB"
        />
      </g>
      <mask id="path-25-inside-7_381_12238" fill="white">
        <path d="M2.51224 17.9852L15.0846 18.4243L14.4565 36.4095L1.88418 35.9704L2.51224 17.9852Z" />
      </mask>
      <path
        d="M2.51224 17.9852L15.0846 18.4243L14.4565 36.4095L1.88418 35.9704L2.51224 17.9852Z"
        fill="white"
      />
      <path
        d="M14.4565 36.4095L14.4677 36.0883L1.8954 35.6493L1.88418 35.9704L1.87296 36.2916L14.4453 36.7306L14.4565 36.4095Z"
        fill="#EDEDED"
        mask="url(#path-25-inside-7_381_12238)"
      />
      <rect
        x="9.97595"
        y="25.2482"
        width="4"
        height="4"
        rx="2"
        transform="rotate(2 9.97595 25.2482)"
        fill="#E9F1F6"
      />
      <g clipPath="url(#clip2_381_12238)">
        <mask id="path-28-inside-8_381_12238" fill="white">
          <path d="M15.0846 18.4243L57.059 19.89L56.4308 37.8791L14.4564 36.4133L15.0846 18.4243Z" />
        </mask>
        <path
          d="M15.0846 18.4243L57.059 19.89L56.4308 37.8791L14.4564 36.4133L15.0846 18.4243Z"
          fill="white"
        />
        <path
          d="M56.4308 37.8791L56.442 37.5579L14.4676 36.0921L14.4564 36.4133L14.4452 36.7345L56.4196 38.2002L56.4308 37.8791Z"
          fill="#EDEDED"
          mask="url(#path-28-inside-8_381_12238)"
        />
        <rect
          x="22.5482"
          y="25.6891"
          width="23.2109"
          height="4"
          rx="2"
          transform="rotate(2 22.5482 25.6891)"
          fill="#DEDFE0"
        />
        <rect
          x="56.5611"
          y="25.0297"
          width="0.32136"
          height="7.70053"
          transform="rotate(2 56.5611 25.0297)"
          fill="#DEDFE0"
        />
        <mask id="path-32-inside-9_381_12238" fill="white">
          <path d="M57.059 19.89L99.0334 21.3558L98.4052 39.3448L56.4308 37.879L57.059 19.89Z" />
        </mask>
        <path
          d="M57.059 19.89L99.0334 21.3558L98.4052 39.3448L56.4308 37.879L57.059 19.89Z"
          fill="white"
        />
        <path
          d="M98.4052 39.3448L98.4164 39.0237L56.442 37.5579L56.4308 37.879L56.4196 38.2002L98.394 39.666L98.4052 39.3448Z"
          fill="#EDEDED"
          mask="url(#path-32-inside-9_381_12238)"
        />
        <rect
          x="64.5227"
          y="27.1549"
          width="23.2109"
          height="4"
          rx="2"
          transform="rotate(2 64.5227 27.1549)"
          fill="#DEDFE0"
        />
        <rect
          x="98.5356"
          y="26.4955"
          width="0.32136"
          height="7.70053"
          transform="rotate(2 98.5356 26.4955)"
          fill="#DEDFE0"
        />
        <mask id="path-36-inside-10_381_12238" fill="white">
          <path d="M99.0334 21.3558L140.008 22.7867L139.38 40.7757L98.4052 39.3449L99.0334 21.3558Z" />
        </mask>
        <path
          d="M99.0334 21.3558L140.008 22.7867L139.38 40.7757L98.4052 39.3449L99.0334 21.3558Z"
          fill="white"
        />
        <path
          d="M139.38 40.7757L139.391 40.4546L98.4164 39.0237L98.4052 39.3449L98.394 39.666L139.369 41.0969L139.38 40.7757Z"
          fill="#EDEDED"
          mask="url(#path-36-inside-10_381_12238)"
        />
        <rect
          x="106.497"
          y="28.6207"
          width="23.2109"
          height="4"
          rx="2"
          transform="rotate(2 106.497 28.6207)"
          fill="#DEDFE0"
        />
        <rect
          x="139.51"
          y="27.9261"
          width="0.32136"
          height="7.70053"
          transform="rotate(2 139.51 27.9261)"
          fill="#DEDFE0"
        />
        <mask id="path-40-inside-11_381_12238" fill="white">
          <path d="M140.008 22.7867L181.983 24.2525L181.355 42.2415L139.38 40.7757L140.008 22.7867Z" />
        </mask>
        <path
          d="M140.008 22.7867L181.983 24.2525L181.355 42.2415L139.38 40.7757L140.008 22.7867Z"
          fill="white"
        />
        <path
          d="M181.355 42.2415L181.366 41.9203L139.391 40.4546L139.38 40.7757L139.369 41.0969L181.343 42.5627L181.355 42.2415Z"
          fill="#EDEDED"
          mask="url(#path-40-inside-11_381_12238)"
        />
        <rect
          x="147.472"
          y="30.0516"
          width="23.2109"
          height="4"
          rx="2"
          transform="rotate(2 147.472 30.0516)"
          fill="#DEDFE0"
        />
        <rect
          x="181.485"
          y="29.3922"
          width="0.32136"
          height="7.70053"
          transform="rotate(2 181.485 29.3922)"
          fill="#DEDFE0"
        />
        <mask id="path-44-inside-12_381_12238" fill="white">
          <path d="M181.983 24.2524L223.957 25.7182L223.329 43.7073L181.355 42.2415L181.983 24.2524Z" />
        </mask>
        <path
          d="M181.983 24.2524L223.957 25.7182L223.329 43.7073L181.355 42.2415L181.983 24.2524Z"
          fill="white"
        />
        <path
          d="M223.329 43.7073L223.34 43.3861L181.366 41.9203L181.355 42.2415L181.343 42.5626L223.318 44.0284L223.329 43.7073Z"
          fill="#EDEDED"
          mask="url(#path-44-inside-12_381_12238)"
        />
        <rect
          x="189.446"
          y="31.5173"
          width="23.2109"
          height="4"
          rx="2"
          transform="rotate(2 189.446 31.5173)"
          fill="#DEDFE0"
        />
        <rect
          x="223.459"
          y="30.8579"
          width="0.32136"
          height="7.70053"
          transform="rotate(2 223.459 30.8579)"
          fill="#DEDFE0"
        />
      </g>
      <mask id="path-48-inside-13_381_12238" fill="white">
        <path d="M1.88417 35.9704L14.4565 36.4094L13.8284 54.3946L1.25611 53.9556L1.88417 35.9704Z" />
      </mask>
      <path
        d="M1.88417 35.9704L14.4565 36.4094L13.8284 54.3946L1.25611 53.9556L1.88417 35.9704Z"
        fill="white"
      />
      <path
        d="M13.8284 54.3946L13.8397 54.0735L1.26733 53.6344L1.25611 53.9556L1.2449 54.2768L13.8172 54.7158L13.8284 54.3946Z"
        fill="#EDEDED"
        mask="url(#path-48-inside-13_381_12238)"
      />
      <rect
        x="9.34789"
        y="43.2334"
        width="4"
        height="4"
        rx="2"
        transform="rotate(2 9.34789 43.2334)"
        fill="#E9F1F6"
      />
      <g clipPath="url(#clip3_381_12238)">
        <mask id="path-51-inside-14_381_12238" fill="white">
          <path d="M14.4565 36.4094L56.4309 37.8752L55.8027 55.8642L13.8283 54.3985L14.4565 36.4094Z" />
        </mask>
        <path
          d="M14.4565 36.4094L56.4309 37.8752L55.8027 55.8642L13.8283 54.3985L14.4565 36.4094Z"
          fill="white"
        />
        <path
          d="M55.8027 55.8642L55.814 55.5431L13.8395 54.0773L13.8283 54.3985L13.8171 54.7196L55.7915 56.1854L55.8027 55.8642Z"
          fill="#EDEDED"
          mask="url(#path-51-inside-14_381_12238)"
        />
        <rect
          x="21.9202"
          y="43.6743"
          width="23.2109"
          height="4"
          rx="2"
          transform="rotate(2 21.9202 43.6743)"
          fill="#DEDFE0"
        />
        <rect
          x="55.9331"
          y="43.0149"
          width="0.32136"
          height="7.70053"
          transform="rotate(2 55.9331 43.0149)"
          fill="#DEDFE0"
        />
        <mask id="path-55-inside-15_381_12238" fill="white">
          <path d="M56.4309 37.8752L98.4053 39.341L97.7772 57.33L55.8027 55.8642L56.4309 37.8752Z" />
        </mask>
        <path
          d="M56.4309 37.8752L98.4053 39.341L97.7772 57.33L55.8027 55.8642L56.4309 37.8752Z"
          fill="white"
        />
        <path
          d="M97.7772 57.33L97.7884 57.0088L55.814 55.5431L55.8027 55.8642L55.7915 56.1854L97.7659 57.6512L97.7772 57.33Z"
          fill="#EDEDED"
          mask="url(#path-55-inside-15_381_12238)"
        />
        <rect
          x="63.8946"
          y="45.1401"
          width="23.2109"
          height="4"
          rx="2"
          transform="rotate(2 63.8946 45.1401)"
          fill="#DEDFE0"
        />
        <rect
          x="97.9075"
          y="44.4807"
          width="0.32136"
          height="7.70053"
          transform="rotate(2 97.9075 44.4807)"
          fill="#DEDFE0"
        />
        <mask id="path-59-inside-16_381_12238" fill="white">
          <path d="M98.4053 39.341L139.38 40.7719L138.752 58.7609L97.7772 57.33L98.4053 39.341Z" />
        </mask>
        <path
          d="M98.4053 39.341L139.38 40.7719L138.752 58.7609L97.7772 57.33L98.4053 39.341Z"
          fill="white"
        />
        <path
          d="M138.752 58.7609L138.763 58.4398L97.7884 57.0089L97.7772 57.33L97.7659 57.6512L138.741 59.0821L138.752 58.7609Z"
          fill="#EDEDED"
          mask="url(#path-59-inside-16_381_12238)"
        />
        <rect
          x="105.869"
          y="46.6059"
          width="23.2109"
          height="4"
          rx="2"
          transform="rotate(2 105.869 46.6059)"
          fill="#DEDFE0"
        />
        <rect
          x="138.882"
          y="45.9113"
          width="0.32136"
          height="7.70053"
          transform="rotate(2 138.882 45.9113)"
          fill="#DEDFE0"
        />
        <mask id="path-63-inside-17_381_12238" fill="white">
          <path d="M139.38 40.7719L181.355 42.2376L180.727 60.2267L138.752 58.7609L139.38 40.7719Z" />
        </mask>
        <path
          d="M139.38 40.7719L181.355 42.2376L180.727 60.2267L138.752 58.7609L139.38 40.7719Z"
          fill="white"
        />
        <path
          d="M180.727 60.2267L180.738 59.9055L138.763 58.4397L138.752 58.7609L138.741 59.082L180.715 60.5478L180.727 60.2267Z"
          fill="#EDEDED"
          mask="url(#path-63-inside-17_381_12238)"
        />
        <rect
          x="146.844"
          y="48.0367"
          width="23.2109"
          height="4"
          rx="2"
          transform="rotate(2 146.844 48.0367)"
          fill="#DEDFE0"
        />
        <rect
          x="180.857"
          y="47.3773"
          width="0.32136"
          height="7.70053"
          transform="rotate(2 180.857 47.3773)"
          fill="#DEDFE0"
        />
        <mask id="path-67-inside-18_381_12238" fill="white">
          <path d="M181.355 42.2376L223.329 43.7034L222.701 61.6924L180.727 60.2266L181.355 42.2376Z" />
        </mask>
        <path
          d="M181.355 42.2376L223.329 43.7034L222.701 61.6924L180.727 60.2266L181.355 42.2376Z"
          fill="white"
        />
        <path
          d="M222.701 61.6924L222.712 61.3713L180.738 59.9055L180.727 60.2266L180.715 60.5478L222.69 62.0136L222.701 61.6924Z"
          fill="#EDEDED"
          mask="url(#path-67-inside-18_381_12238)"
        />
        <rect
          x="188.818"
          y="49.5025"
          width="23.2109"
          height="4"
          rx="2"
          transform="rotate(2 188.818 49.5025)"
          fill="#DEDFE0"
        />
        <rect
          x="222.831"
          y="48.8431"
          width="0.32136"
          height="7.70053"
          transform="rotate(2 222.831 48.8431)"
          fill="#DEDFE0"
        />
      </g>
    </g>
    <rect
      x="3.62253"
      y="0.517145"
      width="221"
      height="88.9809"
      rx="2.07088"
      transform="rotate(2 3.62253 0.517145)"
      stroke="#DEDFE0"
    />
    <defs>
      <clipPath id="clip0_381_12238">
        <rect
          x="3.14029"
          width="222"
          height="89.9809"
          rx="2.57088"
          transform="rotate(2 3.14029 0)"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_381_12238">
        <rect width="222" height="17.9962" fill="white" transform="translate(3.14029) rotate(2)" />
      </clipPath>
      <clipPath id="clip2_381_12238">
        <rect
          width="209"
          height="18"
          fill="white"
          transform="translate(15.0846 18.4243) rotate(2)"
        />
      </clipPath>
      <clipPath id="clip3_381_12238">
        <rect
          width="209"
          height="18"
          fill="white"
          transform="translate(14.4565 36.4094) rotate(2)"
        />
      </clipPath>
    </defs>
  </svg>
);
